import React from 'react';
import footerLogo from 'assets/images/logo-footer.svg';

const DashboardFooter = () => {
    return (
        <footer className="app-footer">
            <div className="app-footer__inner">
                <img className="app-footer__logo" src={footerLogo} alt=""/>
                <p className="app-footer__copyright">
                    &copy; The American Council on Exercise. All Rights Reserved.
                </p>
            </div>
        </footer>
    );
}

export default DashboardFooter;
